<template>
  <product-sub-navigation
    :product="product"
    :variant="variant"
    :liquid="liquid"
    page-type="tech-spec"
    :price="variant?.price?.amount || liquid?.variantPrice"
    always-active
  />

  <div class="product-tech-spec critical-component-clear">
    <div js-sub-navigation="scrollTrigger" />

    <div class="grid">
      <div class="product-tech-spec__header col xs4 l3-10">
        <h2
          :id="`section-title-${liquid.sectionId}`"
          class="product-tech-spec__title text-heading-3xl text-heading-5xl-desktop"
          v-text="liquid.productTitle"
        />
        <p
          v-if="liquid.variantTitle"
          class="product-tech-spec__subtitle text-body-l text-body-xl-desktop"
          v-text="liquid.variantTitle"
        />
      </div>

      <div
        v-if="finishColorsContent"
        class="
          product-tech-spec__row
          tech-spec-row
          col xs4 l3-10
          grid grid--l8
        "
      >
        <div class="tech-spec-row__title-wrapper col xs4 l2">
          <h3
            class="tech-spec-row__title text-heading-xl"
            v-text="$string('product.tech_spec.finish_colors')"
          />
        </div>

        <div class="tech-spec-row__content col xs4 l6">
          <div
            ref="carousel"
            class="tech-spec-row__carousel splide"
            js-carousel="tech-spec-colors"
          >
            <div class="splide__track">
              <div
                class="splide__list"
                v-html="finishColorsContent"
              />
            </div>

            <div class="splide__arrows">
              <button
                class="splide__arrow splide__arrow--secondary splide__arrow--prev"
                type="button"
                :aria-label="$string('accessibility.carousel.previous')"
              >
                <icon-previous />
              </button>

              <button
                class="splide__arrow splide__arrow--secondary splide__arrow--next"
                type="button"
                :aria-label="$string('accessibility.carousel.next')"
              >
                <icon-next />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="dimensionsContent"
        class="
          product-tech-spec__row
          tech-spec-row
          col xs4 l3-10
          grid grid--l8
        "
      >
        <div class="tech-spec-row__title-wrapper col xs4 l2">
          <h3
            class="tech-spec-row__title text-heading-xl"
            v-text="$string('product.tech_spec.dimensions')"
          />
        </div>

        <div
          class="tech-spec-row__content col xs4 l6"
          v-html="dimensionsContent"
        />
      </div>

      <div
        v-if="bodyContent"
        class="
          product-tech-spec__row
          tech-spec-row
          col xs4 l3-10
          grid grid--l8
        "
      >
        <div class="tech-spec-row__title-wrapper col xs4 l2">
          <h3
            class="tech-spec-row__title text-heading-xl"
            v-text="$string('product.tech_spec.body')"
          />
        </div>

        <div class="tech-spec-row__content col xs4 l6">
          <div
            class="tech-spec-row__grid"
            v-html="bodyContent"
          />
        </div>
      </div>

      <div
        v-if="lightOutputContent"
        class="
          product-tech-spec__row
          tech-spec-row
          col xs4 l3-10
          grid grid--l8
        "
      >
        <div class="tech-spec-row__title-wrapper col xs4 l2">
          <h3
            class="tech-spec-row__title text-heading-xl"
            v-text="$string('product.tech_spec.light_output')"
          />
        </div>

        <div class="tech-spec-row__content col xs4 l6">
          <div
            class="tech-spec-row__grid"
            v-html="lightOutputContent"
          />
        </div>
      </div>

      <div
        v-if="appContent"
        class="
          product-tech-spec__row
          tech-spec-row
          col xs4 l3-10
          grid grid--l8
        "
      >
        <div class="tech-spec-row__title-wrapper col xs4 l2">
          <h3
            class="tech-spec-row__title text-heading-xl"
            v-text="$string('product.tech_spec.app')"
          />
        </div>

        <div
          class="tech-spec-row__content col xs4 l6"
          v-html="appContent"
        />
      </div>

      <div
        v-if="downloadsContent"
        class="
          product-tech-spec__row
          tech-spec-row
          col xs4 l3-10
          grid grid--l8
        "
      >
        <div class="tech-spec-row__title-wrapper col xs4 l2">
          <h3
            class="tech-spec-row__title text-heading-xl"
            v-text="$string('product.tech_spec.downloads')"
          />
        </div>

        <div
          class="tech-spec-row__content col xs4 l6"
          v-html="downloadsContent"
        />
      </div>

      <div
        v-if="designContent"
        class="
          product-tech-spec__row
          tech-spec-row
          col xs4 l3-10
          grid grid--l8
        "
      >
        <div class="tech-spec-row__title-wrapper col xs4 l2">
          <h3
            class="tech-spec-row__title text-heading-xl"
            v-text="$string('product.tech_spec.design')"
          />
        </div>

        <div
          class="tech-spec-row__content col xs4 l6"
          v-html="designContent"
        />
      </div>

      <div
        v-if="awardsContent"
        class="
          product-tech-spec__row
          tech-spec-row
          col xs4 l3-10
          grid grid--l8
        "
      >
        <div class="tech-spec-row__title-wrapper col xs4 l2">
          <h3
            class="tech-spec-row__title text-heading-xl"
            v-text="$string('product.tech_spec.awards')"
          />
        </div>

        <div
          class="tech-spec-row__content col xs4 l6"
          v-html="awardsContent"
        />
      </div>

      <div
        v-if="energyEfficiencyContent"
        class="
          product-tech-spec__row
          tech-spec-row
          col xs4 l3-10
          grid grid--l8
        "
      >
        <div class="tech-spec-row__title-wrapper col xs4 l2">
          <h3
            class="tech-spec-row__title text-heading-xl"
            v-text="$string('product.tech_spec.energy_efficiency')"
          />
        </div>

        <div class="tech-spec-row__content col xs4 l6">
          <div
            class="tech-spec-row__grid"
            v-html="energyEfficiencyContent"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Product tech spec (product-tech-spec)
 * -----------------------------------------------------------------------------
 * Section containing tech spec data for a product.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */

import Carousel from '~/api/carousel'
import { values as breakpoints } from '~/config/breakpoints'

import ProductSubNavigation from '~async/product-sub-navigation/product-sub-navigation'
import IconPrevious from '~icons/direction/arrow/left.svg'
import IconNext from '~icons/direction/arrow/right.svg'

import product from '~/graphql/queries/product.gql'
import { formatProduct } from '~/helpers/format'

export default {
  name: 'ProductTechSpec',

  components: {
    IconPrevious,
    IconNext,
    ProductSubNavigation,
  },

  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
        variantId: '',
      }),
    },
    handle: {
      type: String,
      default: cnvs.page.handle,
    },
    product: {
      type: [Boolean, Object],
      default: false,
    },
    variant: {
      type: [Boolean, Object],
      default: false,
    },
    finishColorsContent: {
      type: [Boolean, String],
      default: false,
    },
    dimensionsContent: {
      type: [Boolean, String],
      default: false,
    },
    bodyContent: {
      type: [Boolean, String],
      default: false,
    },
    lightOutputContent: {
      type: [Boolean, String],
      default: false,
    },
    appContent: {
      type: [Boolean, String],
      default: false,
    },
    downloadsContent: {
      type: [Boolean, String],
      default: false,
    },
    designContent: {
      type: [Boolean, String],
      default: false,
    },
    awardsContent: {
      type: [Boolean, String],
      default: false,
    },
    energyEfficiencyContent: {
      type: [Boolean, String],
      default: false,
    },
  },

  emits: {
    'update-request-object': () => true,
  },

  data() {
    return {
      currentHandle: cnvs.page.handle,
      state: 'loading',
      carousel: false,
      carouselConfig: {
        autoWidth: true,
        arrows: false,
        drag: true,
        snap: true,
        speed: 800,
        omitEnd: true,
        type: 'slide',
      },
    }
  },

  mounted() {
    if (this.$refs.carousel) {
      this.initCarousel()
    }

    this.queryProduct()
  },

  methods: {
    initCarousel() {
      const slides = this.$refs.carousel.querySelectorAll('.splide__slide')
      if (slides.length < 1) {
        return
      }

      this.carousel = Carousel(
        `[js-carousel="tech-spec-colors"]`,
        this.carouselConfig,
      )

      /**
       * Add listener to handle carousel overflow.
       * - If there is overflow (more slides than shown on screen), then enable
       *   enable dragging, and enable arrows on desktop.
       * - Otherwise disable dragging and arrows.
       */
      this.carousel.on('overflow', (isOverflow) => {
        const isMobile = !window.matchMedia(`(min-width: ${breakpoints.l}px)`).matches

        this.carousel.options = {
          arrows: isOverflow && !isMobile,
          drag: isOverflow,
        }
      })

      /**
       * Component initiates.
       */
      this.carousel.mount()
    },

    /**
     * Loads product from GraphQL.
     * @param {String} [handle] - Product handle to load.
     */
    async queryProduct(handle = this.handle) {
      if (handle === false) {
        return
      }

      if (this.product.handle === handle) {
        this.state = 'ready'
        return
      }

      try {
        const response = await cnvs.Query({
          query: product,
          variables: {
            country: this.$variable('store.country'),
            handle,
            language: this.$variable('store.language'),
          },
        })

        if (cnvs.settings.disableComponentReadyState) {
          return
        }

        const productData = formatProduct(response)

        this.$emit('update-request-object', {
          response: formatProduct(response),
          type: 'product',
        })

        const variant = productData.variants.find((variantObject) => {
          return variantObject.id === this.liquid.variantId
        })

        if (variant) {
          this.$emit('update-request-object', {
            response: variant,
            type: 'variant',
          })
        }

        this.state = 'ready'

      } catch (error) {
        reportError('Failed to load product', error)
      }
    },
  },
}
</script>

<style lang="scss">
@import './product-tech-spec';
</style>
